import ActionsRouter from '@/router/actions.router';
import i18n from '@/i18n';

const PageActionPlans = () =>
  import(
    /* webpackChunkName: "actionplans" */ '@/pages/actionplans/Actionplans.vue'
  );
const ActionPlansFilter = () =>
  import(
    /* webpackChunkName: "actionplans" */ '@/pages/actionplans/ActionplansFilter.vue'
  );
const ActionPlansTop = () =>
  import(
    /* webpackChunkName: "actionplans" */ '@/pages/actionplans/ActionplansTop.vue'
  );

const PageActionPlan = () =>
  import(
    /* webpackChunkName: "actionplan" */ '@/pages/actionplan/Actionplan.vue'
  );
const ActionplanDrawer = () =>
  import(
    /* webpackChunkName: "actionplan" */ '@/pages/actionplan/ActionplanDrawer.vue'
  );
const ActionPlanTop = () =>
  import(
    /* webpackChunkName: "actionplan" */ '@/pages/actionplan/ActionPlanTop.vue'
  );

export const ACTIONPLANS_LIST_ROUTE_NAME = 'actionplans-list';
export const ACTIONPLANS_ITEM_ROUTE_NAME = 'actionplans-item';

export default {
  getActionPlansRoute() {
    return {
      path: 'actionplans',
      name: ACTIONPLANS_LIST_ROUTE_NAME,
      components: {
        top: ActionPlansTop,
        default: PageActionPlans,
        'right-drawer': ActionPlansFilter,
      },
      meta: {
        authorizations: ['isMy360'],
        title: 'actionplans',
        icon: i18n.t('message.actionplans.icon'),
      },
    };
  },
  getActionPlanRoute() {
    return {
      path: 'actionplans/:actionplanId',
      name: ACTIONPLANS_ITEM_ROUTE_NAME,
      props: true,
      components: {
        top: ActionPlanTop,
        default: PageActionPlan,
        'right-drawer': ActionplanDrawer,
      },
      meta: {
        isHidden: true,
        parent: 'actionplans',
      },
      children: [
        ActionsRouter.getActionsRoute(),
        ActionsRouter.getActionRoute(),
      ],
    };
  },
};
